import type { User } from "firebase/auth";
import { defineStore } from "pinia";
import { ref } from "vue";

import type { GetUserQuery } from "@/sdk";

export const useUserStore = defineStore("userStore", () => {
	const user = ref<null | User>(null);
	const userData = ref<null | GetUserQuery["user"][0]>(null);

	const setUser = (firebaseUser: User) => {
		user.value = firebaseUser;
	};
	const setUserData = (newUserData: any) => {
		userData.value = newUserData;
	};

	return {
		user,
		setUser,

		userData,
		setUserData,
	};
});
